var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { Card, Button, Table } from 'antd';
import dayjs from 'dayjs';
import React, { useMemo, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useQuery } from '@tanstack/react-query';
import YearRangeFilter from '../../dashboard/components/filter/year-range-filter';
import { fetchAdminFemaleNoMatchUsers, fetchFemaleNoMatchReasons, fetchFemaleNoMatchReasonsDetail } from '../../cores/api/api-dashboard';
const EMPTY_CHART_STATE = {
    labels: [],
    values: []
};
const TABLE_PAGE_SIZE = 20;
const buildNoMatchDateParams = range => {
    if (range.mode === 'month') {
        const baseDate = dayjs(`${range.year}-${String(range.month).padStart(2, '0')}-01`);
        return {
            from: baseDate.startOf('month').format('YYYY-MM-DD'),
            to: baseDate.endOf('month').format('YYYY-MM-DD')
        };
    }
    if (range.mode === 'year') {
        return {
            from: dayjs(`${range.year}-01-01`).startOf('year').format('YYYY-MM-DD'),
            to: dayjs(`${range.year}-12-31`).endOf('year').format('YYYY-MM-DD')
        };
    }
    return {
        from: dayjs(`${range.startYear}-01-01`).startOf('year').format('YYYY-MM-DD'),
        to: dayjs(`${range.endYear}-12-31`).endOf('year').format('YYYY-MM-DD')
    };
};
export const ChartFemaleNoMatchReason = () => {
    var _a, _b, _c, _d;
    const now = new Date();
    const _useState = useState('chart'), _useState2 = _slicedToArray(_useState, 2), viewMode = _useState2[0], setViewMode = _useState2[1];
    const _useState3 = useState(1), _useState4 = _slicedToArray(_useState3, 2), tablePage = _useState4[0], setTablePage = _useState4[1];
    const _useState5 = useState(TABLE_PAGE_SIZE), _useState6 = _slicedToArray(_useState5, 2), tablePageSize = _useState6[0], setTablePageSize = _useState6[1];
    const _useState7 = useState({
        mode: 'year',
        year: now.getFullYear()
    }), _useState8 = _slicedToArray(_useState7, 2), params = _useState8[0], setParams = _useState8[1];
    const handleParamsChange = nextParams => {
        setTablePage(1);
        setTablePageSize(TABLE_PAGE_SIZE);
        setParams(nextParams);
    };
    const mappingData = items => {
        const map = new Map();
        (items !== null && items !== void 0 ? items : []).forEach(group => {
            group.items.forEach(item => {
                var _a;
                const current = (_a = map.get(item.title)) !== null && _a !== void 0 ? _a : 0;
                map.set(item.title, current + item.count);
            });
        });
        return {
            labels: Array.from(map.keys()),
            values: Array.from(map.values())
        };
    };
    const mergeResponsesToChartState = responses => {
        const map = new Map();
        responses.forEach(response => {
            var _a;
            ((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : []).forEach(group => {
                group.items.forEach(item => {
                    var _a;
                    const current = (_a = map.get(item.title)) !== null && _a !== void 0 ? _a : 0;
                    map.set(item.title, current + item.count);
                });
            });
        });
        return {
            labels: Array.from(map.keys()),
            values: Array.from(map.values())
        };
    };
    const _useQuery = useQuery({
        queryKey: ['female-no-match-reason', params],
        suspense: true,
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (params.mode === 'month') {
                const res = yield fetchFemaleNoMatchReasonsDetail({
                    year: params.year,
                    month: params.month
                });
                return mappingData((_a = res === null || res === void 0 ? void 0 : res.data) !== null && _a !== void 0 ? _a : []);
            }
            if (params.mode === 'year') {
                const res = yield fetchFemaleNoMatchReasons({
                    year: params.year
                });
                return mappingData((_b = res === null || res === void 0 ? void 0 : res.data) !== null && _b !== void 0 ? _b : []);
            }
            const years = Array.from({
                length: params.endYear - params.startYear + 1
            }, (_, index) => params.startYear + index);
            const responses = yield Promise.all(years.map(year => fetchFemaleNoMatchReasons({
                year
            })));
            return mergeResponsesToChartState(responses);
        })
    }), data = _useQuery.data;
    const chartState = data !== null && data !== void 0 ? data : EMPTY_CHART_STATE;
    const tableFilterParams = useMemo(() => _objectSpread(_objectSpread({}, buildNoMatchDateParams(params)), {}, {
        page: tablePage,
        per_page: tablePageSize
    }), [params, tablePage, tablePageSize]);
    const _useQuery2 = useQuery({
        queryKey: ['female-no-match-reason-table', tableFilterParams],
        queryFn: () => fetchAdminFemaleNoMatchUsers(tableFilterParams),
        enabled: viewMode === 'table'
    }), tableResponse = _useQuery2.data, isTableLoading = _useQuery2.isLoading, isTableFetching = _useQuery2.isFetching;
    const chartData = {
        labels: chartState.labels,
        datasets: [{
                label: '理由割合',
                data: chartState.values,
                backgroundColor: '#ff7875'
            }]
    };
    const tableColumns = [{
            title: 'ユーザーID',
            dataIndex: 'user_id',
            width: 120,
            render: userId => /*#__PURE__*/ React.createElement("a", {
                href: `/userpage?id=${userId}`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "text-blue-600 hover:underline"
            }, "@", userId)
        }, {
            title: 'Email',
            dataIndex: 'email',
            width: 240
        }, {
            title: 'ノーマッチ理由',
            dataIndex: ['no_match_reason_category', 'name'],
            width: 340,
            render: value => value || '-'
        }, {
            title: 'その他の理由',
            dataIndex: 'reason_text',
            render: value => value
        }, {
            title: '日時',
            dataIndex: 'no_matched_at',
            width: 200,
            render: value => dayjs(value).format('YYYY-MM-DD HH:mm:ss')
        }];
    const tableData = (_a = tableResponse === null || tableResponse === void 0 ? void 0 : tableResponse.data) !== null && _a !== void 0 ? _a : [];
    const tableMeta = tableResponse === null || tableResponse === void 0 ? void 0 : tableResponse.meta;
    return /*#__PURE__*/ React.createElement(Card, {
        title: "\u5973\u6027\u306E\u30CE\u30FC\u30DE\u30C3\u30C1\u7406\u7531",
        extra: /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center gap-4"
        }, /*#__PURE__*/ React.createElement(YearRangeFilter, {
            onChange: handleParamsChange
        }), /*#__PURE__*/ React.createElement("div", {
            className: "flex gap-2"
        }, /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('chart'),
            className: viewMode === 'chart' ? '!bg-[#f0c52a36]' : ''
        }, "\u30B0\u30E9\u30D5"), /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('table'),
            className: viewMode === 'table' ? '!bg-[#f0c52a36]' : ''
        }, "\u8868"))),
        styles: {
            body: {
                paddingTop: '4px',
                height: 400
            }
        }
    }, viewMode === 'chart' ? /*#__PURE__*/ React.createElement("div", {
        style: {
            height: 350
        }
    }, /*#__PURE__*/ React.createElement(Bar, {
        data: chartData,
        options: {
            indexAxis: 'y',
            responsive: true,
            maintainAspectRatio: false
        }
    })) : /*#__PURE__*/ React.createElement(Table, {
        rowKey: record => `${record.user_id}-${record.no_matched_at}`,
        columns: tableColumns,
        dataSource: tableData,
        loading: isTableLoading || isTableFetching,
        pagination: {
            current: (_b = tableMeta === null || tableMeta === void 0 ? void 0 : tableMeta.page) !== null && _b !== void 0 ? _b : tablePage,
            pageSize: (_c = tableMeta === null || tableMeta === void 0 ? void 0 : tableMeta.per_page) !== null && _c !== void 0 ? _c : tablePageSize,
            total: (_d = tableMeta === null || tableMeta === void 0 ? void 0 : tableMeta.total_count) !== null && _d !== void 0 ? _d : 0,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            onChange: (page, pageSize) => {
                if (pageSize !== tablePageSize) {
                    setTablePage(1);
                    setTablePageSize(pageSize);
                    return;
                }
                setTablePage(page);
            }
        },
        scroll: {
            y: 280
        },
        locale: {
            emptyText: 'データがありません'
        }
    }));
};
